<template>
    <div class="head">
        <div class="container">
            <div class="left_box">
                <div class="dept_name">
                    <img src="../../assets/static/index/icons.png" alt="">
                    <span>{{ deptInfo.deptName }}</span>
                </div>
                <div class="info_box">
                    <div class="info_item">
                        <span class="iconfont icon-dangzuzhiziyuan"></span>
                        <span class="value">{{ deptInfo.deptType }}</span>
                    </div>
                    <div class="info_item">
                        <span class="iconfont icon-party-r"></span>
                        <span class="value">{{ deptInfo.userCount }}人</span>
                    </div>
                </div>
            </div>
            <div class="right_box">
                <el-button>
                    <router-link to="/">返回主页</router-link>
                </el-button>
                <el-button v-if="!token">
                    <router-link to="/login">登录</router-link>
                </el-button>
            </div>
        </div>
        <!-- navbar -->
        <div class="navbar_box">
            <div class="navbar_content">
                <div class="nav_item" @click="NavClick(item, index)" :class="activeNavIndex == index ? 'active_nav' : '' " v-for="(item, index) in NavbarList" :key="index" >
                    {{ item.name  }}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                NavbarList: [


                ],
                activeNavIndex: 0,
                deptInfo: {},
            }
        },
        created() {
            this.init()
            this.getNavIndex()
        },
        computed: {
            deptId () {
                return localStorage.deptId
            },
            token () {
                return localStorage.token
            }
        },
        watch: {
            deptId () {
                this.init()
            }
        },
        mounted() {
            console.log("id是:" + this.$store.getters.deptId )
        },

        methods: {
            // 初始化
            init() {
                console.log( this.deptInfo )
                this.NavbarList = [
                    { name: "首页", path: `/ZuzhiInfo/${ this.deptId }` },
                    { name: "组织动态", path: `/DeptMoreNews/${ this.deptId }?cate_id=200&isSearch=0&keyword=` },
                    { name: "三会一课", path: `/DeptMeeting/meeting/1/${this.deptId}?activeMain=0` },
                    { name: "组织活动", path: `/DeptMeeting/meeting/1/${this.deptId}?activeMain=1` },
                    { name: "组织相册", path: `/DeptPhoto/${ this.deptId }` },
                    { name: "组织成员", path: `/MemberList/${ this.deptId }` },
                ]
                this.getDeptInfo()
            },
            // 点击导航
            NavClick( item , index ) {
                this.activeNavIndex = index 
                localStorage.setItem("activeIndex", index)
                this.$router.push( item.path )
            },
            // 计算导航索引值
            getNavIndex () {
               let index = localStorage.activeIndex 
               if ( index != null ) {
                   this.activeNavIndex = index
               }
            },
            // 获取支部信息
            async getDeptInfo () {
                this.deptInfo = {}
                let { token,deptId } = this 
                console.log( deptId )
                let res = await this.$axios.post("/lencon/pc/dept/detail", { token, deptId: Number(deptId) })
                if ( res.data.code == 1 ) {
                    this.deptInfo = res.data.obj
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
.head {
    max-width: 100%;
    width: 100%;
    height: 240px;
    background: url("../../assets/static/zhibu/zuzhi_bg.jpg") 0 0 no-repeat;
    background-size: cover;
    position: relative;
    left: 0;
    top: 0;
    .container {
        width: 1200px;
        margin: 0 auto;
        padding-top: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left_box {
            width: 500px;
            .dept_name {
                font-size: 35px;
                font-weight: bold;
                color: #fff;
                display: flex;
                align-items: center;
                img {
                    margin-right: 20px;
                }
            }
            .info_box {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .info_item {
                    margin: 10px;
                    .iconfont {
                        color: #FEE2BB;
                        margin-right: 10px;
                    }
                    .value {
                        color: #fff;
                    }
                }
            }
        }
        .right_box {
            padding-right: 130px;
            .el-button {
                width: 125px;
                height: 37px;
                background: rgba(255, 255, 255, 0.26);
                border-radius: 5px;
                border: none;
                
            }
        }
    }
    .navbar_box {
        max-width:  100%;
        width: 100%;
        height: 60px;
        position: absolute;
        left: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.15);
        .navbar_content {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            .nav_item {
                width: 150px;
                height: 60px;
                box-sizing: border-box;
                font-size: 18px;
                line-height: 60px;
                color: #fff;
                text-align: center;
                cursor: pointer;
            }
            .active_nav {
                background: #2767c4 ;
            }
        }
    }
}
</style>